import template from './index.pug'

export default {
  name: 'CookieTable',
  template: template(),
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => [] // [{ cookie, type, expiry, owner, purpose }]
    }
  }
}
